import { render, staticRenderFns } from "./ErrorLogo.vue?vue&type=template&id=372146a3&scoped=true"
import script from "./ErrorLogo.vue?vue&type=script&lang=js"
export * from "./ErrorLogo.vue?vue&type=script&lang=js"
import style0 from "./ErrorLogo.vue?vue&type=style&index=0&id=372146a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372146a3",
  null
  
)

export default component.exports